import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';

export interface TableColumn {
    key: string;
    label: string;
    type?: 'text' | 'image' | 'badge' | 'currency' | 'date' | 'custom' | 'phone' | 'email' | 'rating';
    sortable?: boolean;
    cssClass?: string;
    getValue?: (item: any) => any;
    badgeClass?: (item: any) => string;
}

export interface TableAction {
    id: string;
    icon: string;
    color?: string;
    label?: string;
    cssClass?: string;
}

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss'],
    standalone: true,
    imports: [CommonModule, IonicModule, FormsModule]
})
export class DataTableComponent implements OnInit, OnChanges {
    @Input() columns: TableColumn[] = [];
    @Input() data: any[] = [];
    @Input() loading: boolean = false;
    @Input() pageSize: number = 10;
    @Input() actions: TableAction[] = [];
    @Input() currencySymbol: string = '$';
    @Input() emptyMessage: string = 'No records found in the current sector.';
    @Input() searchPlaceholder: string = 'Scan registry metadata...';
    @Input() showSearch: boolean = true;
    @Input() mobileCardTitleKey: string = ''; // Key to use as title in mobile card view

    @Output() actionClick = new EventEmitter<{ actionId: string, item: any }>();
    @Output() rowClick = new EventEmitter<any>();

    currentPage: number = 0;
    filteredData: any[] = [];
    searchTerm: string = '';

    constructor() { }

    ngOnInit() {
        this.applyFilter();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['data']) {
            this.applyFilter();
        }
    }

    applyFilter(event?: any) {
        if (event) {
            this.searchTerm = event.target.value.toLowerCase();
            this.currentPage = 0;
        }

        if (!this.searchTerm) {
            this.filteredData = [...this.data];
        } else {
            this.filteredData = this.data.filter(item => {
                return this.columns.some(col => {
                    const val = this.getCellValue(item, col);
                    return val && String(val).toLowerCase().includes(this.searchTerm);
                });
            });
        }
    }

    getCellValue(item: any, col: TableColumn): any {
        if (col.getValue) {
            return col.getValue(item);
        }
        return item[col.key];
    }

    onActionClick(actionId: string, item: any, event: Event) {
        event.stopPropagation();
        this.actionClick.emit({ actionId, item });
    }

    onRowClick(item: any) {
        this.rowClick.emit(item);
    }

    get totalPages(): number {
        return Math.ceil(this.filteredData.length / this.pageSize);
    }

    get displayedData(): any[] {
        const start = this.currentPage * this.pageSize;
        return this.filteredData.slice(start, start + this.pageSize);
    }

    nextPage() {
        if ((this.currentPage + 1) < this.totalPages) {
            this.currentPage++;
        }
    }

    previousPage() {
        if (this.currentPage > 0) {
            this.currentPage--;
        }
    }

    get hasData(): boolean {
        return this.filteredData.length > 0;
    }
}
